import { render } from "./HiddenFields.vue?vue&type=template&id=07ed584b"
import script from "./HiddenFields.vue?vue&type=script&lang=js"
export * from "./HiddenFields.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__